const newNotifications = (state) => state.newNotifications
const activeNotifications = (state) => state.activeNotifications
const recentNotifications = (state) => state.recentNotifications
const showNotificationBar = (state) => state.showNotificationBar

export default {
  newNotifications,
  activeNotifications,
  recentNotifications,
  showNotificationBar,
}